import React from 'react';
import './Load.css'; // 样式可根据需求自定义

interface LoadProps {
    loader?: React.ReactNode; // 自定义加载动画或占位符
}

const Load: React.FC<LoadProps> = ({ loader }) => {
    return (
        <div className="load-container">
            <div className="loader">{loader || <DefaultLoader/>}</div>
        </div>
    );
};

const DefaultLoader: React.FC = () => {
    return (
        <div className="load-container">
            <div className="container container-1">
                <div className="dot dot-1"></div>
                <div className="dot dot-2"></div>
                <div className="dot dot-3"></div>
                <div className="dot dot-4"></div>
            </div>
            <div className="container container-2">
                <div className="dot dot-1"></div>
                <div className="dot dot-2"></div>
                <div className="dot dot-3"></div>
                <div className="dot dot-4"></div>
            </div>
            <div className="container container-3">
                <div className="dot dot-1"></div>
                <div className="dot dot-2"></div>
                <div className="dot dot-3"></div>
                <div className="dot dot-4"></div>
            </div>
        </div>

    );
};

export default Load;
